import styles from "./AddMeetingModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useState, useEffect } from "react";
import Button from "shared/Button";
import DatePicker from "ManagementTeam/Shared/DatePicker";
import TimePicker from "ManagementTeam/Shared/TimePicker";
import Select from "ManagementTeam/Shared/Select";
import RadioButtonList from "ManagementTeam/Shared/RadioButtonList";
import DatePickerCalendar from "../DatePickerCalendar";
import Auth from "shared/@auth";
import {
  convertTimeZoneDisplayText,
  convertTimeZoneValue,
} from "ManagementTeam/utils/timezone";
import Checkbox from "ManagementTeam/Shared/Checkbox";

/**
 *
 * Modal when adding an agenda item on the agenda page
 * Notes: All dates and times need to be get without UTC to have the raw input for the BE handle
 */

export function AddMeetingModal({
  meetingType,
  meetingInfo,
  isOpen,
  onClose,
  onSave,
  onSaveDraft,
  onDelete,
  currentMonthYear,
}) {
  const { hasPermission } = Auth.useContainer();
  const [dateOneCalendarOpen, setDateOneCalendarOpen] = useState(false);
  const [dateTwoCalendarOpen, setDateTwoCalendarOpen] = useState(false);
  const [length, setLength] = useState("");
  const [ifNeeded, setIfNeeded] = useState(false);
  var dayAfterTomorrowsDate = new Date();
  dayAfterTomorrowsDate.setHours(0);
  dayAfterTomorrowsDate.setDate(dayAfterTomorrowsDate.getDate());
  var tomorrowsDate = new Date(dayAfterTomorrowsDate);
  dayAfterTomorrowsDate.setDate(dayAfterTomorrowsDate.getDate() + 1);

  const [meetingId, setMeetingId] = useState("");

  const [date1, setDate1] = useState(null);
  const [date2, setDate2] = useState(null);

  const [startTime1, setStartTime1] = useState("");
  const [startTime2, setStartTime2] = useState("");
  const [endTime1, setEndTime1] = useState("");
  const [endTime2, setEndTime2] = useState("");

  const [timeZone1, setTimeZone1] = useState(null);
  const [timeZone2, setTimeZone2] = useState(null);

  const [inPerson, setInPerson] = useState(null);
  const [location, setLocation] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  const [virtual, setVirtual] = useState(null);
  const [zoomLink, setZoomLink] = useState("");
  const [meetingPasscode, setMeetingPasscode] = useState("");
  const [zoomMeetingId, setZoomMeetingId] = useState("");

  const [checkIn, setCheckIn] = useState(null);
  // const [meetingType, setMeetingType] = useState(null);

  const [endMeeting, setEndMeeting] = useState(false);
  const [deliveryType, setDeliveryType] = useState("");
  const [isDraft, setIsDraft] = useState(true);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (meetingInfo) {
      if (meetingInfo.dates) {
        if (meetingInfo.dates.length > 0) {
          var d1 = parseUTCTimeIgnoreLocal(meetingInfo.dates[0].startsOn);
          setDate1(formatDate(d1));

          setStartTime1(
            formatTimeFROMdb(d1.getHours() + ":" + d1.getMinutes())
          );
          var d1End = parseUTCTimeIgnoreLocal(meetingInfo.dates[0].endsOn);
          setEndTime1(
            formatTimeFROMdb(d1End.getHours() + ":" + d1End.getMinutes())
          );
          setTimeZone1(
            convertTimeZoneDisplayText(meetingInfo.dates[0].timeZone)
          );

          if (meetingInfo.dates.length > 1) {
            var d2 = parseUTCTimeIgnoreLocal(meetingInfo.dates[1].startsOn);
            setDate2(formatDate(d2));
            setStartTime2(
              formatTimeFROMdb(d2.getHours() + ":" + d2.getMinutes())
            );

            var d2End = parseUTCTimeIgnoreLocal(meetingInfo.dates[1].endsOn);
            setEndTime2(
              formatTimeFROMdb(d2End.getHours() + ":" + d2End.getMinutes())
            );
            setTimeZone2(
              convertTimeZoneDisplayText(meetingInfo.dates[1].timeZone)
            );

            setLength("2 Day");
          } else {
            // but default the second day to the day after the first
            var d2 = new Date(d1);
            d2.setDate(d2.getDate() + 1);
            setDate2(formatDate(d2));
            setStartTime2(
              meetingType === "Management Team" ? "10:00 a.m" : "12:00 p.m"
            );
            setEndTime2("5:00 p.m.");
            setTimeZone2(
              convertTimeZoneDisplayText(meetingInfo.dates[0].timeZone)
            );

            setLength("1 Day");
          }
        }
      }

      if (meetingInfo.inPerson) {
        setInPerson(meetingInfo.inPerson);
        setLocation(meetingInfo.inPerson.location);
        setState(meetingInfo.inPerson.state);
        setCity(meetingInfo.inPerson.city);
      }

      if (meetingInfo.virtual) {
        setVirtual(meetingInfo.virtual);
        setZoomLink(
          meetingInfo.virtual.zoomLink ? meetingInfo.virtual.zoomLink : ""
        );
        setMeetingPasscode(
          meetingInfo.virtual.meetingPasscode
            ? meetingInfo.virtual.meetingPasscode
            : ""
        );
        setZoomMeetingId(
          meetingInfo.virtual.meetingId ? meetingInfo.virtual.meetingId : ""
        );
      }

      setCheckIn(meetingInfo.checkIn);
      setEndMeeting(meetingInfo.endMeeting);
      setDeliveryType(
        meetingInfo.deliveryType?.length > 1
          ? "Virtual & In-person"
          : meetingInfo.deliveryType[0]
      );
      setMeetingId(meetingInfo.id);
      setIsDraft(meetingInfo.isDraft);
      setIsComplete(meetingInfo.isComplete);
      if (meetingInfo.ifNeeded !== null || meetingInfo.ifNeeded !== undefined) {
        setIfNeeded(meetingInfo.ifNeeded);
      }
    } else {
      setMeetingId("");
      if (!currentMonthYear) {
        setDate1(formatDate(tomorrowsDate));
        setDate2(formatDate(dayAfterTomorrowsDate));
      }
      setStartTime1(
        meetingType === "Management Team" ? "10:00 a.m" : "12:00 p.m"
      );
      setStartTime2(
        meetingType === "Management Team" ? "10:00 a.m" : "12:00 p.m"
      );
      setEndTime1("5:00 p.m.");
      setEndTime2("5:00 p.m.");
      setTimeZone1("Pacific Time (PT)");
      setTimeZone2("Pacific Time (PT)");

      setInPerson(null);
      setLocation("");
      setVirtual(null);
      setZoomLink("");
      setMeetingPasscode("");
      setZoomMeetingId("");

      setDeliveryType("");
      setIsDraft(true);
      setIsComplete(false);

      setLength("1 Day");
    }
  }, [meetingInfo]);

  function getMonthFromDateString(dateString) {
    if (!dateString) return null;

    const [monthRaw] = dateString.split(".");
    const month = Number(monthRaw);

    return month ? month - 1 : null;
  }

  useEffect(() => {
    if (currentMonthYear) {
      const curYear = parseInt(currentMonthYear.substring(3, 7));
      const curMonth = parseInt(currentMonthYear.substring(0, 2)) - 1;
      if (meetingInfo) {
        return;
      } else if (
        curMonth === new Date().getMonth() &&
        curMonth === getMonthFromDateString(date1)
      ) {
        return;
      } else if (currentMonthYear && !meetingInfo) {
        var date = new Date(curYear, curMonth);
        setDate1(formatDate(new Date(date.getFullYear(), date.getMonth(), 1)));
        setDate2(formatDate(new Date(date.getFullYear(), date.getMonth(), 2)));
      }
    }
  }, [currentMonthYear, meetingInfo]);
  function formatDate(date) {
    return (
      date.getMonth() +
      1 +
      "." +
      date.getDate() +
      "." +
      (date.getFullYear() - 2000)
    );
  }
  function formatTimeForDB(timeString) {
    var split = timeString.split(":");
    var hour = parseInt(split[0].replace(/[^0-9]+/g, ""));
    var minutes = split[1].replace(/[^0-9]+/g, "");

    if (timeString.toLowerCase().indexOf("a") != -1 && hour == 12) {
      hour = 0;
    }
    if (timeString.toLowerCase().indexOf("p") != -1 && hour != 12) {
      hour += 12;
    }

    if (hour < 10) {
      hour = "0" + hour.toString();
    }

    return hour + ":" + minutes + ":00";
  }
  function formatTimeFROMdb(timeString) {
    var split = timeString.split(":");
    var hour = parseInt(split[0].replace(/[^0-9]+/g, ""));
    var minutes = split[1].replace(/[^0-9]+/g, "");

    var am = "a.m.";
    if (hour > 11) {
      am = "p.m.";
    }
    if (hour > 12) {
      hour -= 12;
    }

    if (hour == 0) {
      hour = 12;
    }

    if (minutes.length < 2) {
      minutes = "0" + minutes;
    }
    return hour + ":" + minutes + " " + am;
  }
  function formatDateForDB(dateString) {
    if (!dateString) return null;

    const [monthRaw, dayRaw, yearRaw] = dateString.split(".");
    const month = Number(monthRaw);
    const day = Number(dayRaw);
    const year = Number(yearRaw);

    if (!month || !day || Number.isNaN(year)) return null;

    const fullYear = year < 100 ? 2000 + year : year;

    return `${fullYear}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;
  }
  function getDates() {
    var dates = [
      {
        startDate: formatDateForDB(date1),
        startTime: formatTimeForDB(startTime1),
        endTime: formatTimeForDB(endTime1),
        timeZone: convertTimeZoneValue(timeZone1),
      },
    ];

    if (length == "2 Day") {
      dates.push({
        startDate: formatDateForDB(date2),
        startTime: formatTimeForDB(startTime2),
        endTime: formatTimeForDB(endTime2),
        timeZone: convertTimeZoneValue(timeZone2),
      });
    }

    return dates;
  }

  function getMeetingReqBody(isDraft) {
    var b = {
      meetingType: meetingType == "Management Team" ? "MT" : "EC",
      deliveryType:
        deliveryType === "Decision Only Meeting"
          ? ["Decision"]
          : deliveryType.split(" & "),
      dates: getDates(),
      isDraft: isDraft,
      ifNeeded: ifNeeded,
    };

    if (location) {
      b.location = location;
      b.city = city;
      b.state = state;
    }

    if (zoomLink) {
      b.zoomLink = zoomLink;
      b.meetingId = zoomMeetingId;
      b.meetingPasscode = meetingPasscode;
    }

    if (meetingInfo) {
      // for editing
      if (meetingInfo.id) {
        b.id = meetingInfo.id;
      }
    }
    return b;
  }

  function toggleDateOneCalendar() {
    if (dateOneCalendarOpen) {
      setDateOneCalendarOpen(false);
    } else {
      setDateOneCalendarOpen(true);
    }
  }

  function toggleDateTwoCalendar() {
    if (dateTwoCalendarOpen) {
      setDateTwoCalendarOpen(false);
    } else {
      setDateTwoCalendarOpen(true);
    }
  }
  function parseUTCTimeIgnoreLocal(dateString) {
    const date = new Date(dateString);
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    const res = new Date(date.getTime() + userTimezoneOffset);
    return res;
  }
  return (
    isOpen && (
      <>
        <div className={styles.modalContainer}>
          <div className={styles.modalHeader}>
            <Button
              visible={hasPermission("management-team.admins")}
              className={styles.saveAsDraftButton}
              children="Save As Draft"
              onClick={() => onSaveDraft(getMeetingReqBody(true))}
              disabled={
                !deliveryType ||
                ((deliveryType === "In-person" ||
                  deliveryType === "Virtual & In-person") &&
                  (!location || !city || !state))
              }
            />
            <Button
              visible={hasPermission("management-team.admins")}
              className={styles.saveButton}
              children="Save"
              onClick={() => onSave(getMeetingReqBody(false))}
              disabled={
                !deliveryType ||
                ((deliveryType === "In-person" ||
                  deliveryType === "Virtual & In-person") &&
                  (!location || !city || !state))
              }
            />
            <Button
              visible={hasPermission("management-team.admins")}
              purpose="delete"
              className={
                meetingId !== "" ? styles.deleteButton : styles.displayNone
              }
              children="Delete"
              onClick={() => onDelete(meetingId)}
            />
            <Button
              className={styles.cancelButton}
              children="Cancel"
              onClick={() => onClose()}
            />
          </div>
          <div className={styles.modalBody}>
            <div className={styles.labelMargin}>Meeting For</div>

            {meetingType === "Management Team" ? (
              <div className={styles.meetingForText}>Management Team</div>
            ) : (
              <div className={styles.meetingForText}>Executive Committee</div>
            )}
            <div
              className={classNames(
                styles.meetingTypeContainer,
                styles.labelMargin
              )}
            >
              <div className={styles.meetingTypeTextContainer}>
                Meeting Type<sup>*</sup>
              </div>
              <div className={classNames(styles.hr, styles.centerHr)} />
            </div>

            <div className={styles.editFieldsContainer}>
              <div className={styles.meetingTypeSelectContainer}>
                <Select
                  className={styles.select1}
                  selectedOption={deliveryType}
                  onChange={setDeliveryType}
                  placeholder="Choose"
                  options={[
                    "Virtual",
                    "In-person",
                    "Virtual & In-person",
                    "Decision Only Meeting",
                  ]}
                />
                {(deliveryType.toLowerCase() === "in-person" ||
                  deliveryType === "Virtual & In-person") && (
                  <div className={styles.locationContainer}>
                    <div className={styles.locationLabel}>
                      Location<sup>*</sup>
                    </div>
                    <input
                      readOnly={!hasPermission("management-team.admins")}
                      type="text"
                      className={classNames(styles.input, styles.locationInput)}
                      onChange={(e) => setLocation(e.target.value)}
                      value={location ? location : ""}
                    />
                    <div className={styles.cityStateLabel}>
                      <span className={styles.cityLabel}>
                        City<sup>*</sup>
                      </span>
                      <span>
                        State<sup>*</sup>
                      </span>
                    </div>
                    <input
                      readOnly={!hasPermission("management-team.admins")}
                      type="text"
                      className={classNames(styles.input, styles.cityInput)}
                      onChange={(e) => setCity(e.target.value)}
                      value={city ? city : ""}
                      placeholder="City..."
                    />

                    <input
                      readOnly={!hasPermission("management-team.admins")}
                      type="text"
                      className={classNames(styles.input, styles.stateInput)}
                      onChange={(e) => setState(e.target.value)}
                      value={state ? state : ""}
                      placeholder="State..."
                    />
                  </div>
                )}
              </div>

              {(deliveryType.toLowerCase() == "virtual" ||
                deliveryType == "Virtual & In-person") && (
                <div className={styles.virtualContainer}>
                  <div className={styles.zoomlink}>Zoom Link</div>
                  <textarea
                    readOnly={!hasPermission("management-team.admins")}
                    className={styles.zoomLinkInput}
                    onChange={(e) => setZoomLink(e.target.value)}
                    value={zoomLink ? zoomLink : ""}
                  ></textarea>

                  <div className={styles.zoomGrid}>
                    <div>
                      <div className={styles.locationLabel}>Meeting ID</div>
                      <input
                        readOnly={!hasPermission("management-team.admins")}
                        type="text"
                        className={styles.input}
                        value={zoomMeetingId ? zoomMeetingId : ""}
                        onChange={(e) => setZoomMeetingId(e.target.value)}
                      />
                    </div>
                    <div>
                      <div className={styles.locationLabel}>
                        Meeting Passcode
                      </div>
                      <input
                        readOnly={!hasPermission("management-team.admins")}
                        type="text"
                        className={styles.input}
                        value={meetingPasscode ? meetingPasscode : ""}
                        onChange={(e) => setMeetingPasscode(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className={styles.hr} />

            <div className={styles.labelMargin}>Meeting Length</div>
            <div className={styles.meetingLengthFlex}>
              <RadioButtonList
                readOnly={!hasPermission("management-team.admins")}
                selectedOption={length}
                options={["1 Day", "2 Day"]}
                onClick={setLength}
                direction="horizontal"
                customClassName={styles.radioButtons}
              />
              <div className={styles.meetingLengthFlex}>
                <Checkbox
                  className={styles.checkboxIfNeeded}
                  checked={ifNeeded}
                  onChange={() => {
                    setIfNeeded(!ifNeeded);
                  }}
                />
                Add “if needed” to PDF Agenda
              </div>
            </div>
            <div className={styles.dateTimeGrid}>
              <div className={styles.labelMargin}>Day 1 Starts</div>
              <div className={styles.labelMargin}>Day 1 Ends</div>
              <div></div>

              <div className={styles.dateTimeGridItem}>
                <div
                  className={classNames(
                    styles.dateOneCalendar,
                    !dateOneCalendarOpen && styles.displayNone
                  )}
                >
                  <DatePickerCalendar
                    selectedDate={
                      meetingInfo && meetingInfo.dates[0]
                        ? formatDate(
                            parseUTCTimeIgnoreLocal(
                              meetingInfo.dates[0].startsOn
                            )
                          )
                        : formatDate(tomorrowsDate)
                    }
                    changeSelectedDate={(e) => {
                      setDate1(formatDate(new Date(e)));
                    }}
                  />
                </div>
                <DatePicker
                  readOnly={!hasPermission("management-team.admins")}
                  dateString={date1}
                  setDate={setDate1}
                  toggleCalendar={toggleDateOneCalendar}
                />
              </div>
              <div></div>
              <div className={styles.labelMargin}>Time Zone</div>
              <TimePicker
                readOnly={!hasPermission("management-team.admins")}
                timeString={startTime1}
                onChange={setStartTime1}
              />

              <div
                className={classNames(
                  styles.dateTimeGridItem,
                  styles.marginRight36px
                )}
              >
                <TimePicker
                  readOnly={!hasPermission("management-team.admins")}
                  timeString={endTime1}
                  onChange={setEndTime1}
                />
              </div>

              <Select
                disabled={!hasPermission("management-team.admins")}
                selectedOption={timeZone1}
                onChange={setTimeZone1}
                placeholder="Choose"
                options={[
                  "Pacific Time (PT)",
                  "Mountain Time (MT)",
                  "Central Time (CT)",
                  "Eastern Time (ET)",
                ]}
                className={styles.timeZoneSelect}
              />
              <div></div>
            </div>

            <div
              className={classNames(
                styles.dateTimeGrid,
                length != "2 Day" && styles.invisible
              )}
            >
              <div className={styles.labelMargin}>Day 2 Starts</div>
              <div className={styles.labelMargin}>Day 2 Ends</div>
              <div></div>

              <div className={styles.dateTimeGridItem}>
                <div
                  className={classNames(
                    styles.dateTwoCalendar,
                    !dateTwoCalendarOpen && styles.displayNone
                  )}
                >
                  <DatePickerCalendar
                    selectedDate={
                      meetingInfo && meetingInfo.dates[1]
                        ? formatDate(
                            parseUTCTimeIgnoreLocal(
                              meetingInfo.dates[1].startsOn
                            )
                          )
                        : formatDate(tomorrowsDate)
                    }
                    changeSelectedDate={(e) =>
                      setDate2(formatDate(new Date(e)))
                    }
                  />
                </div>
                <DatePicker
                  readOnly={!hasPermission("management-team.admins")}
                  dateString={date2}
                  setDate={setDate2}
                  toggleCalendar={toggleDateTwoCalendar}
                />
              </div>
              <div></div>
              <div className={styles.labelMargin}>Time Zone</div>
              <TimePicker
                readOnly={!hasPermission("management-team.admins")}
                timeString={startTime2}
                onChange={setStartTime2}
              />
              <div
                className={classNames(
                  styles.dateTimeGridItem,
                  styles.marginRight36px
                )}
              >
                <TimePicker
                  readOnly={!hasPermission("management-team.admins")}
                  timeString={endTime2}
                  onChange={setEndTime2}
                />
              </div>

              <Select
                disabled={!hasPermission("management-team.admins")}
                selectedOption={timeZone2}
                onChange={setTimeZone2}
                placeholder="Choose"
                options={[
                  "Pacific Time (PT)",
                  "Mountain Time (MT)",
                  "Central Time (CT)",
                  "Eastern Time (ET)",
                ]}
                className={styles.timeZoneSelect}
              />
              <div></div>
            </div>
          </div>
        </div>
      </>
    )
  );
}

AddMeetingModal.propTypes = {
  meetingInfo: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onSaveDraft: PropTypes.func,
  onDelete: PropTypes.func,
};
